export const Repeat = ({
	count,
	children,
}: {
	count?: number
	children: any
}) => Array.from({ length: count ?? 5 }, () => children)
